import { create } from 'zustand';

// Tracks in-flight filing operations per target folder so the folder row can
// show a loader while a mail is being uploaded/converted/stored. A ref-count
// (not a boolean) so concurrent files into the same folder don't clear the
// spinner early.
interface FilingState {
  counts: Record<string, number>;
  begin: (folderId: string) => void;
  end: (folderId: string) => void;
}

export const useFilingStore = create<FilingState>((set) => ({
  counts: {},
  begin: (folderId) =>
    set((s) => ({ counts: { ...s.counts, [folderId]: (s.counts[folderId] ?? 0) + 1 } })),
  end: (folderId) =>
    set((s) => {
      const next = { ...s.counts };
      const remaining = (next[folderId] ?? 0) - 1;
      if (remaining <= 0) delete next[folderId];
      else next[folderId] = remaining;
      return { counts: next };
    }),
}));

// Subscribe to just one folder's filing state (avoids re-rendering every row
// when an unrelated folder starts filing).
export function useIsFiling(folderId: string): boolean {
  return useFilingStore((s) => (s.counts[folderId] ?? 0) > 0);
}
